export const POST_STREAM_ITEM_METHODS = {
  commentable: 'item.setCommentable',
  pin: 'item.setPinnedUntil',
  rebuzzable: 'item.setRebuzzable',
  public: 'item.setPublic',
  createThread: 'item.createThread',
  addThread: 'item.addToThread',
};
